import { getTranslation } from '../api/project';


export const deeplTranslate = async (text: string, lang: string) => {
  try {
    return await getTranslation(text, lang);
  } catch (e) {
    console.log(e);
    return;
  }
};
